import React from 'react';
import { Lock } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-cream/10 bg-noir-900 py-8 sm:py-10" data-id="element-103" data-mp="3gf94uw0pu68y">
      <div className="container flex flex-col items-center gap-3 text-center sm:gap-4" data-id="element-104" data-mp="3ghc2o28413o8">
        <p className="font-display text-lg font-semibold text-cream" data-id="element-105" data-mp="32pp764lzrz6i">
          Bundle Conexión Real — 5 Volúmenes
        </p>
        <p className="flex items-center gap-2 text-xs text-cream/45" data-id="element-106" data-mp="3uf0phflqmkvx">
          <Lock className="h-3.5 w-3.5 text-gold-500" aria-hidden="true" data-id="element-107" data-mp="3uftm3nqzfu0c" />
          Pago seguro · Acceso inmediato · Garantía de 30 días
        </p>
        <p className="text-[11px] text-cream/30" data-id="element-108" data-mp="3levgj10wbefn">
          © {new Date().getFullYear()} Todos los derechos reservados. Los resultados
          varían según la aplicación de cada persona.
        </p>
      </div>
    </footer>;
}